// The help centre's routes (not sitemap screens; docs/v3/FEEDBACK-PLAN.md).
import { PAGES } from "@convenor/shared";
import { extra, page, type AreaRoute } from "../../routes/types";

export const routes: AreaRoute[] = [
  extra(PAGES.help, page(() => import("./pages/HelpPage"), "TeamHelpPage"), { allowNoOrg: true }),
  extra(PAGES.portalHelp, page(() => import("./pages/HelpPage"), "ExpertHelpPage")),
];
